module.exports = __webpack_public_path__ + "static/media/quartz_201.5bd9056f.ico";